// extracted by mini-css-extract-plugin
module.exports = {"container":"ClockStops_container__DUPiV","btn":"ClockStops_btn__3BOhH"};